import '@src/styles/components/collapseCard.scss';
import { Collapse } from 'antd';
import { CustomImage } from './index';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import iconDown from '@src/assets/icons/icon-down.svg';
import iconUp from '@src/assets/icons/icon-up.svg';
import { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Text } from '@src/components';

const { Panel } = Collapse;

function getExpandIcon(isActive, diffPage) {
  return isActive ? (
    <CustomImage className="open-close" src={!diffPage ? iconUp : iconDown} />
  ) : (
    <CustomImage className="open-close" src={!diffPage ? iconDown : iconUp} />
  );
}

const CustomCollapseCard = ({
  children,
  cardTitle,
  cardTitle2 = null,
  cardTitleAlign,
  bodyCenter,
  className,
  headerRightInfo,
  diffPage = false,
  selectedCustomer = false,
  selectedCustomerInfo = '',
  showExpandIcon = true,
  titleColor = null,
  titleSize = '16px',
  isExpand = true,
}) => {
  const isMobil = useMediaQuery({ query: '(max-width: 1179.98px)' });
  const [isExpanded, setIsExpanded] = useState(true);
  const [activeKey, setActiveKey] = useState('1');

  const handleExpandChange = useCallback((isActive) => {
    setIsExpanded(isActive);
    if (!isActive) {
      setActiveKey('0');
    } else {
      setActiveKey('1');
    }
  }, []);

  useEffect(() => {
    setIsExpanded(true);
  }, []);

  useEffect(() => {
    if (!isExpand) {
      setActiveKey('0');
      setIsExpanded(false);
    }
  }, [isExpand]);

  useEffect(() => {
    if (selectedCustomer) {
      handleExpandChange(false);
    }
  }, [selectedCustomer?.customerId]);

  return (
    <>
      <Collapse
        defaultActiveKey={['1']}
        className={`${className || ''} custom-collapse-card ${
          selectedCustomer && !isExpanded ? 'admin-custom-collapse-card' : ''
        }`}
        allowAsProps={true}
        expandIconPosition="right"
        showArrow={false}
        ghost
        activeKey={activeKey}
        bordered={false}
        onChange={(key) => handleExpandChange(key.length > 0)}
        expandIcon={({ isActive }) => (showExpandIcon ? getExpandIcon(isActive, diffPage) : null)}
      >
        <Panel
          header={
            <>
              <div
                style={{
                  fontSize: titleSize,
                  color: titleColor ?? '#050505',
                  textAlign: isMobil ? 'left' : cardTitleAlign || 'left',
                }}
              >
                {!isExpanded && cardTitle2 ? cardTitle2 : cardTitle}
              </div>
              {isExpanded && headerRightInfo && (
                <div className="header-right-info">{headerRightInfo}</div>
              )}
            </>
          }
          key="1"
        >
          <div className={bodyCenter ? 'd-flex justify-content-center' : ''}>{children}</div>
        </Panel>
      </Collapse>
      {selectedCustomer && !isExpanded && (
        <div className="admin-management-car-collapse-user-info-div">
          <p className="admin-management-car-collapse-user-info"> {selectedCustomerInfo}</p>
          <button
            onClick={() => handleExpandChange(true)}
            className="admin-management-car-collapse-user-info-change"
          >
            {' '}
            <Text t="change" />
          </button>
        </div>
      )}
    </>
  );
};

CustomCollapseCard.propTypes = {
  children: PropTypes.any,
  cardTitle: PropTypes.object,
  cardTitle2: PropTypes.any,
  cardTitleAlign: PropTypes.string,
  titleColor: PropTypes.string,
  titleSize: PropTypes.string,
  bodyCenter: PropTypes.any,
  className: PropTypes.any,
  headerRightInfo: PropTypes.any,
  diffPage: PropTypes.bool,
  selectedCustomer: PropTypes.bool,
  selectedCustomerInfo: PropTypes.string,
  showExpandIcon: PropTypes.bool,
  isExpand: PropTypes.bool,
};

export default CustomCollapseCard;
